import cuid from 'cuid';

const SESSION_ID_STORAGE_KEY = 'lio-session-id';

let inMemorySessionId: string | null = null;

/**
 * Generate or retrieve the session ID for the current browser session.
 * Session ID persists across page reloads but clears when tab is closed.
 */
export const getOrCreateSessionId = (): string => {
  if (typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined') {
    try {
      let sessionId = window.sessionStorage.getItem(SESSION_ID_STORAGE_KEY);
      if (!sessionId) {
        sessionId = cuid();
        window.sessionStorage.setItem(SESSION_ID_STORAGE_KEY, sessionId);
      }
      return sessionId;
    } catch {
      // Fall through to in-memory fallback if storage is blocked or throws.
    }
  }

  if (!inMemorySessionId) {
    inMemorySessionId = cuid();
  }

  return inMemorySessionId;
};
